import { IconButton } from '@cian/ui-kit';
import { IconToggleStarOff16, IconToggleStarOff24 } from '@cian/ui-kit-design-tokens/icons';
import * as React from 'react';

type TChatHeaderMarkStarredButton = {
  isMobile: boolean;
  onClick: () => void;
};

export const ChatHeaderMarkStarredButton: React.FC<TChatHeaderMarkStarredButton> = ({ isMobile, onClick }) => {
  return isMobile ? (
    <IconButton
      onClick={onClick}
      icon={<IconToggleStarOff24 color="icon-main-default" />}
      data-testid="ChatHeaderMarkStarredButton"
    />
  ) : (
    <IconButton onClick={onClick} icon={<IconToggleStarOff16 />} data-testid="ChatHeaderMarkStarredButton" />
  );
};
